/**
 * @generated SignedSource<<5315d829fd314f89c337f1829cda4437>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuySharedAsyncModules_viewer$data = {
  readonly buyPageItemRecommendations?: {
    readonly " $fragmentSpreads": FragmentRefs<"BuySharedPersonalizedSearchItems_buyPageItemRecommendations" | "SharedYMAL_buyPageItemRecommendations">;
  } | null;
  readonly buyPageSoldResults?: {
    readonly " $fragmentSpreads": FragmentRefs<"SharedRecentSales_buyPageSoldResults">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"BuySharedPersonalizedSearchItems_viewer" | "SharedRecentSales_viewer" | "SharedYMAL_viewer">;
  readonly " $fragmentType": "BuySharedAsyncModules_viewer";
};
export type BuySharedAsyncModules_viewer$key = {
  readonly " $data"?: BuySharedAsyncModules_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuySharedAsyncModules_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "uriRef",
  "variableName": "uriRef"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplayOrBtSsr"
    },
    {
      "kind": "RootArgument",
      "name": "categoryLevel"
    },
    {
      "kind": "RootArgument",
      "name": "isClient"
    },
    {
      "kind": "RootArgument",
      "name": "topItemIds"
    },
    {
      "kind": "RootArgument",
      "name": "uriRef"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedAsyncModules_viewer",
  "selections": [
    {
      "condition": "afterDisplayOrBtSsr",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            (v0/*:: as any*/)
          ],
          "concreteType": "BuyPageSoldResults",
          "kind": "LinkedField",
          "name": "buyPageSoldResults",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SharedRecentSales_buyPageSoldResults"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "categoryLevel",
              "variableName": "categoryLevel"
            },
            {
              "kind": "Variable",
              "name": "topItemIds",
              "variableName": "topItemIds"
            },
            (v0/*:: as any*/)
          ],
          "concreteType": "BuyPageItemRecommendations",
          "kind": "LinkedField",
          "name": "buyPageItemRecommendations",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SharedYMAL_buyPageItemRecommendations"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "BuySharedPersonalizedSearchItems_buyPageItemRecommendations"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRecentSales_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedYMAL_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuySharedPersonalizedSearchItems_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "23cf73e5c8d974f9839238dbc559d356";

export default node;
